import {Component, inject} from '@angular/core';
import {CommonModule} from "@angular/common";
import {Router, RouterLink} from "@angular/router";
import {
    DxButtonModule,
    DxDataGridModule,
    DxFormModule,
    DxTemplateModule
} from "devextreme-angular";
import {DxDataGridTypes} from "devextreme-angular/ui/data-grid";
import {BinGridViewDto, StorageType} from "@services";
import EnumUtils from "../../../shared/enum-utils";
import {GridPageComponent, FilterConfig} from "../../common/grid-page.component";
import {FilterPanelComponent} from "../../../components/library/filter-panel/filter-panel.component";

@Component({
    selector: 'app-bins',
    imports: [
        CommonModule,
        DxDataGridModule,
        DxFormModule,
        DxTemplateModule,
        DxButtonModule,
        FilterPanelComponent,
        RouterLink,
    ],
    templateUrl: './bins.component.html',
    styleUrl: './bins.component.scss',
})
export class BinsComponent extends GridPageComponent<BinGridViewDto> {
    private router = inject(Router);

    constructor() {
        super();
        this.init(BinGridViewDto);
    }

    dataSource = this.dataSources.bins();
    binTypeOptions = EnumUtils.getEnumOptions(StorageType);

    protected override exportName: string = "Bins";

    protected override filterConfig: FilterConfig[] = [
        {field: 'number', op: 'contains'},
        {field: 'storageType', op: 'contains'},
        {field: 'storageBinType', op: 'contains'},
        {field: 'type', op: '='},
        {field: 'maxPallets', op: '>='},
        {field: 'aisle', op: 'contains'},
        {field: 'zone', op: 'contains'}
    ];

    override async onRowDblClick(e: DxDataGridTypes.RowDblClickEvent) {
        const {data} = e;
        await this.router.navigate([`/inventory/storage-bins/details/${data.number}`]);
    }
}

